export default __webpack_public_path__ + "static/media/quality.e6275ba6.png";